import { render, staticRenderFns } from "./onlineCommunication.vue?vue&type=template&id=5846686f"
import script from "./onlineCommunication.vue?vue&type=script&lang=js"
export * from "./onlineCommunication.vue?vue&type=script&lang=js"
import style0 from "./onlineCommunication.vue?vue&type=style&index=0&id=5846686f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports